/**
 * DatabaseIcon/index.js
 * desc: Database icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const DatabaseIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="database icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.database.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 20 24" xmlns="http://www.w3.org/2000/svg"><path d="M10 .75c-5.525 0-10 2.237-10 5 0 2.762 4.475 5 10 5s10-2.238 10-5c0-2.763-4.475-5-10-5zM0 8.25V12c0 2.762 4.475 5 10 5s10-2.238 10-5V8.25c0 2.762-4.475 5-10 5s-10-2.238-10-5zm0 6.25v3.75c0 2.762 4.475 5 10 5s10-2.238 10-5V14.5c0 2.762-4.475 5-10 5s-10-2.238-10-5z" /></svg>
    </IconButton>
);


export default DatabaseIcon;
